<!-- 促销价格 -->
<template>
  <div>
    <!-- 直降 -->
    <StraightDownPrice
      v-if="allAcvitityInfo.activeType === 1"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
      :currentTime="currentTime"
      @triggerGetActive="receiveGetActive"
    />
    <!-- 秒杀 -->
    <SeckillPrice
      v-else-if="allAcvitityInfo.activeType === 2 || allAcvitityInfo.activeType === 3"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
      :currentTime="currentTime"
      @triggerGetActive="receiveGetActive"
    />
    <!-- 优惠券 -->
    <CouponPrice
      v-else-if="allAcvitityInfo.activeType === 4"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
    />
    <GroupBuyPrice
      v-else-if="allAcvitityInfo.activeType === 5"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import SeckillPrice from '../../seckill/seckillPrice.vue';
import StraightDownPrice from '../../straightDown/straightDownPrice.vue';
import CouponPrice from '../../coupon/couponPrice.vue';
import GroupBuyPrice from './groupBuy/GroupBuyPrice.vue';
import { reqproductDetailDiscount } from '../../../api/courseDetail/courseAcvitity/index';
// import { reqCurrentTime } from '../../../api/courseDetail/index';
import { replaceHyphens } from '../../../utils/tools';

export default {
  data() {
    return {
      salePrice: 0,
      allAcvitityInfo: {}, // 产品详情页所有的活动数据
      activeType: 0, // 活动类型  0无单品促销活动  1 直降 2 限时秒杀 3 限量秒杀  4优惠券  5 拼团 6分享
      nowAcvitity: {}, //  当前展示的活动信息
      currentTime: 0,
    };
  },
  components: {
    SeckillPrice,
    StraightDownPrice,
    CouponPrice,
    GroupBuyPrice,
  },
  props: {},
  computed: {
    ...mapState(['courseBaseData', 'productSku', 'userInfo']),
  },
  watch: {
    productSku(data) {
      this.getAcvitity();
      // this.getServerTime();
      this.salePrice = data.productSkuId ? data.price : this.courseBaseData.sellPrice;
    },
    userInfo() {
      if (!this.productSku.productSkuId) return;
      // 登录成功后更新优惠券列表的领取状态（针对已领取的优惠券）
      this.getAcvitity();
      // this.getServerTime();
    },
    courseBaseData(data) {
      // 默认取产品的价格
      this.salePrice = data.sellPrice;
    },
  },
  mounted() {
  },
  methods: {
    // 服务器时间
    // async getServerTime() {
    //   const current = await reqCurrentTime();
    //   this.currentTime = current.data
    //     ? new Date(replaceHyphens(current.data)).getTime()
    //     : new Date().getTime();
    // },
    // 查询所有活动，优惠券和单品折扣活动同时存在的时候，已单品折扣为主
    async getAcvitity() {
      if (!this.productSku.productSkuId) return;
      const activeType = 0;
      const nowAcvitity = {};
      Object.assign(this.allAcvitityInfo, { activeType, nowAcvitity });
      this.saveAcvitity();
    },
    // 更新活动状态
    receiveGetActive() {
      // this.getServerTime();
      this.getAcvitity();
    },
    // 活动保存到vuex
    saveAcvitity() {
      this.$store.dispatch('saveAllAcvitity', this.allAcvitityInfo);
    },
  },
};
</script>
